import PropTypes from 'prop-types';

/**
 * RecurringScheduleIcon - vaadin:time-forward icon
 * A clock with a forward/refresh arrow indicating recurring schedule
 */
function RecurringScheduleIcon({ className }) {
  return (
    <svg
      className={className}
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Clock circle */}
      <path
        d="M5.5 10C7.98528 10 10 7.98528 10 5.5C10 3.01472 7.98528 1 5.5 1C3.01472 1 1 3.01472 1 5.5C1 7.98528 3.01472 10 5.5 10Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Clock hands */}
      <path
        d="M5.5 3V5.5L7 7"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Forward/refresh arrow */}
      <path
        d="M8.5 2.5L10 1M10 1V3M10 1H8"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

RecurringScheduleIcon.propTypes = {
  className: PropTypes.string,
};

RecurringScheduleIcon.defaultProps = {
  className: '',
};

export default RecurringScheduleIcon;
